import React from 'react';
import StaticDropdown from 'components/form/field/static-dropdown';
import { getFormLabel } from '../helpers';

export default ({ providers, field }) => (
  <StaticDropdown fieldName={getFormLabel(providers, field)} field={field.value} variant="raw" />
);
